import * as React from "react";
import { SolutionsEcommProvider, EcommFacetProvider, SolutionsStickyCTA, ProductImageGallery, useProductDetailSlots, ProductDetailFullWidth, ProductDetailStack, ProductDetailDescription, ProductDetailFeatures, SolutionsDetailsList, SolutionsLegalDisclaimer, ProductDetailDisclaimer, ProductDetailDrawerStack, ProductDetailSpecification, ProductDetailManufacturerDrawer, ProductDetailReviewsDrawer, SolutionsEcommContent, mapServerToSolutionsProduct, getSolutionsBySlug } from "@grandvisionhq/fun-products";
import { P as ProductPageLayoutBase, a as ProductPageBase, g as defaultSolutionsFacetConfig, f as fetchProductConfigBySlug, h as handleValidations } from "../../ProductPageLayoutBase.js";
import { c as defaultSolutionsFlatFacetConfig } from "../../default-flat-facet-configs.js";
import { CmsComponentSlot } from "@grandvisionhq/bloomreach";
const EcommContent = (props) => /* @__PURE__ */ React.createElement(SolutionsEcommContent, { ...props });
const PrimaryProductInfo = (props) => /* @__PURE__ */ React.createElement(ProductDetailStack, { ...props }, /* @__PURE__ */ React.createElement(ProductDetailDescription, { className: "product-detail-stack__description" }, /* @__PURE__ */ React.createElement(ProductDetailFeatures, null), /* @__PURE__ */ React.createElement(SolutionsDetailsList, null), /* @__PURE__ */ React.createElement(SolutionsLegalDisclaimer, null)), /* @__PURE__ */ React.createElement(ProductDetailDisclaimer, { className: "product-detail-stack__disclaimer" }), /* @__PURE__ */ React.createElement(ProductDetailDrawerStack, { className: "product-detail-stack__drawer-stack" }, /* @__PURE__ */ React.createElement(ProductDetailSpecification, null), /* @__PURE__ */ React.createElement(ProductDetailManufacturerDrawer, null), /* @__PURE__ */ React.createElement(ProductDetailReviewsDrawer, null)));
const SecondaryProductInfo = () => {
  const { Slots: OpcoSlots } = useProductDetailSlots();
  return /* @__PURE__ */ React.createElement(ProductDetailFullWidth, null, /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/row-pdp-container" }), OpcoSlots.SecondaryProductInfoSlot && /* @__PURE__ */ React.createElement(OpcoSlots.SecondaryProductInfoSlot, null));
};
const SolutionsDetailPage = (props) => /* @__PURE__ */ React.createElement(SolutionsEcommProvider, { ...props }, /* @__PURE__ */ React.createElement(EcommFacetProvider, null, /* @__PURE__ */ React.createElement(
  ProductPageLayoutBase,
  {
    EcommContent,
    ImageGallery: ProductImageGallery,
    PrimaryProductInfo,
    StickyCta: SolutionsStickyCTA,
    SecondaryProductInfo
  }
)));
const Page = ({
  maxOrderableQuantity,
  facetConfigList,
  ...props
}) => /* @__PURE__ */ React.createElement(ProductPageBase, { ...props, facetConfigList: facetConfigList ?? defaultSolutionsFacetConfig }, /* @__PURE__ */ React.createElement(SolutionsDetailPage, { maxOrderableQuantity }));
Page.getInitialProps = async (ctx) => {
  const productConfig = await fetchProductConfigBySlug(
    ctx,
    getSolutionsBySlug,
    mapServerToSolutionsProduct,
    ctx.pageConfig?.facetConfigList ?? defaultSolutionsFacetConfig,
    defaultSolutionsFlatFacetConfig
  );
  if ("failure" in productConfig) {
    return handleValidations(productConfig, `Error while initializing Solutions PDP`);
  }
  const { product, activeVariant, sku, slug, bloomreachPathOverride } = productConfig;
  return {
    sku,
    slug,
    product,
    activeVariant,
    bloomreachPathOverride
  };
};
export {
  Page
};
//# sourceMappingURL=solutions.js.map
